//
// Generated class BookingChannel
//

/// <reference path="BookingChannel_ManagedObject.ts" />

class BookingChannel extends BookingChannel_ManagedObject
{
}
